import React from 'react';
import { IHardToPlaceDonor } from "@nkr/models/index";
import { Alert, Button, Modal } from "react-bootstrap";
import HardToPlaceDonorsGrid from "./hard-to-place-donors-grid";

interface IProps {
    show: boolean,
    isAdmin: boolean,
    center: string,
    data: IHardToPlaceDonor[],
    onHideModal: () => void
}

const HardToPlaceDonorsModal = (props: IProps) => {
    if (props.data == null) {
        return <></>;
    }

    return (
        <Modal backdrop='static' dialogClassName='hard-to-place-donor-modal' show={props.show} onHide={props.onHideModal}>
            <Modal.Header closeButton>
                <Modal.Title>{props.center ? props.center : 'Network'} - Hard to Place Donor Add Back Audit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='info' bsSize='sm'>This list includes both partner centers and member centers</Alert>

                <HardToPlaceDonorsGrid isAdmin={props.isAdmin} data={props.data} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHideModal}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default HardToPlaceDonorsModal;